import { DistributionCenterInventory } from '@api/DistributionCenterInventories/DistributionCenterInventory';
import DistributionCenterInventoryServ from '@api/DistributionCenterInventories/DistributionCenterInventoryServ';
import { Input } from '@api/Inputs/Input';

class DistributionCenterInventoryService {
    saveInventory = (inventory: DistributionCenterInventory): Promise<DistributionCenterInventory> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await DistributionCenterInventoryServ.saveInventory(inventory);
                resolve(data);
            } catch (error) {
                reject('Error saving distribution center inventory: ' + error);
            }
        });
    };
    getInventory = (distributionCenterId: string, fillEmpty?: boolean): Promise<DistributionCenterInventory[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await DistributionCenterInventoryServ.getInventory(distributionCenterId, fillEmpty);
                resolve(data);
            } catch (error) {
                reject('Error getting distribution center inventory: ' + error);
            }
        });
    };
    deleteInventory = (inventory: DistributionCenterInventory): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await DistributionCenterInventoryServ.deleteInventory(inventory);
                resolve();
            } catch (error) {
                reject('Error deleting distribution center inventory: ' + error);
            }
        });
    };

    updateInputInventory = (inventoryId: string, input: Input, stock: number): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await DistributionCenterInventoryServ.updateInputInventory(inventoryId, input, stock);
                resolve();
            } catch (error) {
                reject('Error updating input inventory: ' + error);
            }
        });
    };
}
export default DistributionCenterInventoryService;
